import { render, staticRenderFns } from "./BaseListTable.vue?vue&type=template&id=237a7eca&"
import script from "./BaseListTable.vue?vue&type=script&lang=ts&"
export * from "./BaseListTable.vue?vue&type=script&lang=ts&"
import style0 from "./BaseListTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports